module.exports = {
  messages: {
    CRATE_LEBENSLAUF_NAVIGATION_ADVISORY: 'Ratgeber',
    CRATE_LEBENSLAUF_NAVIGATION_STRUCTURE: 'Aufbau und Inhalt',
    CRATE_LEBENSLAUF_STARTPAGE_ARTICLES_READ_MORE: 'Weiterlesen',
    LEBENSLAUF_ARTICLE_CAROUSEL_DESCRIPTION:
      'Artikel mit Themen-Schwerpunkten, Tipps und mehr:',
    LEBENSLAUF_ARTICLE_CAROUSEL_TITLE: 'Tipps zu diesem Thema',
    LEBENSLAUF_GENERIC_ERROR_BODY:
      'Vielleicht klappt\'s wieder, wenn Du auf "Aktualisieren" klickst.',
    LEBENSLAUF_GENERIC_ERROR_BUTTON: 'Nochmal versuchen',
    LEBENSLAUF_GENERIC_ERROR_TITLE: 'Warum siehst Du hier nichts?',
  },
};
